/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileEquipment
 */
export interface StoreProfileEquipment {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileEquipment
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileEquipment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileEquipment
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileEquipment
     */
    icon: string;
}

/**
 * Check if a given object implements the StoreProfileEquipment interface.
 */
export function instanceOfStoreProfileEquipment(value: object): value is StoreProfileEquipment {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function StoreProfileEquipmentFromJSON(json: any): StoreProfileEquipment {
    return StoreProfileEquipmentFromJSONTyped(json, false);
}

export function StoreProfileEquipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileEquipment {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'],
        'icon': json['icon'],
    };
}

export function StoreProfileEquipmentToJSON(json: any): StoreProfileEquipment {
    return StoreProfileEquipmentToJSONTyped(json, false);
}

export function StoreProfileEquipmentToJSONTyped(value?: StoreProfileEquipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

